import { MantineProvider as BaseMantineProvider, createTheme } from '@mantine/core';

import theme from '../styles/theme.ts';

export function MantineProvider({ children }: { children: React.ReactNode }) {
  return <BaseMantineProvider theme={createTheme(theme)}>{children}</BaseMantineProvider>;
}
